import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getCouriers } from '../../../../../store/action/courier';
import { isAuthenticated } from '../../../../../store/action/auth';

export default function (props) {
    const [ view, setView ] = useState(false);
    const [ options, setOptions ] = useState([]);
    const [ selectedCouriers, setSelectedCouriers ] = useState([]);

    useEffect(() => {
        _fetchData()
    },[]);

    useEffect(() => {
        let selected = [];
        for(let i = 0; i < props.value.length; i ++) {
            for (let j = 0; j < options.length; j ++) {
                if (props.value[i] === options[j].value) {
                    selected.push({
                        label:options[j].label,
                        value:options[j].value
                    })
                    continue;
                }
            }
        }
        setSelectedCouriers(selected);
    },[props.value]);

    const _fetchData = async () => {
        const response = await getCouriers(isAuthenticated().token);
        if (response.success) {
            let courierChecker = [];
            const formattedCourier = response.couriers.reduce((r,i) => {
                if (!courierChecker.includes(i.courierCode)) {
                    r.push({
                        value:i.courierCode,
                        label:i.courierName
                    })
                    courierChecker.push(i.courierCode);
                }
                return r
            },[])
            setOptions(formattedCourier)
        };
    };

    const onChangeCourier = (e) => {
        if (e) {
            const selectedCouriers = e.reduce((r,i) => {
                r.push(i.value);
                return r
            },[])
            setSelectedCouriers(selectedCouriers);
            props.onChange(selectedCouriers)
            return;
        };
        setSelectedCouriers([]);
        props.onChange([]);
        return;
    }

    return (
        <div className="border-bottom">
            <div className={`${view ? null : "filter-view"}`}>
                <div className="py-3 container">
                    <div 
                        className="pointer row justify-content-between px-4" 
                        onClick={props.open ? props.onClickOpen : props.onClickClose}
                    >
                        Nama kurir
                    </div>
                </div>
            </div>
           
            {
                props.open ? 
                    <div className="bg-lighter p-4">
                        <Select
                            isMulti
                            value={selectedCouriers}
                            onChange={e => onChangeCourier(e)}
                            options={options}
                            placeholder="Masukkan nama kurir"
                        />
                    </div>
                    : 
                    null
            }
        </div>

    )
};